<template>
  <div
    v-if="brandImage"
    class="flex-none flex gap-y-5 h-6 justify-center"
  >
    <a
      :href="brandUrl"
      :title="brandTitle"
      class="flex-none flex items-center"
    >
      <ImgView
        :src="brandImage"
        :alt="brandTitle"
      />
    </a>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'TrustedBrandItem',

  props: {
    brandUrl: {
      type: String,
      default: '',
    },
    brandTitle: {
      type: String,
      default: '',
    },
    brandImage: {
      type: String,
      default: '',
    },
  },
});

</script>
